import { ApiTypes } from "types"

import MonitoringPageContentView from "./MonitoringPageContentView"

interface MonitoringPageContentProps {
  devices: ApiTypes.Model.Device[]
  meta: ApiTypes.Model.Pagination | undefined
  isFetching: boolean
  onPerformanceTestSuccess: () => void
}

const MonitoringPageContent = ({ devices, meta, isFetching, onPerformanceTestSuccess }: MonitoringPageContentProps) => {
  return (
    <MonitoringPageContentView
      devices={devices}
      meta={meta}
      isFetching={isFetching}
      onPerformanceTestSuccess={onPerformanceTestSuccess}
    />
  )
}

export default MonitoringPageContent
